import { render, staticRenderFns } from "./ks.vue?vue&type=template&id=3f96e2dc&scoped=true&"
import script from "./ks.vue?vue&type=script&lang=js&"
export * from "./ks.vue?vue&type=script&lang=js&"
import style0 from "./ks.vue?vue&type=style&index=0&id=3f96e2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96e2dc",
  null
  
)

export default component.exports